import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from '@reach/router';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { ReactComponent as Instagram } from '../../images/svg/instagram.svg';
import { ReactComponent as Facebook } from '../../images/svg/facebook.svg';
import { ReactComponent as LinkedIn } from '../../images/svg/linkedin.svg';
import classes from './Footer.module.css';
import paypalLogo from './paypal.png';
import dhlLogo from './dhl.png';
import { getPage } from '../../utils/pages';

const WILDLING_ABOUT_DE = 'https://www.wildling.shoes/';
const WILDLING_ABOUT_EN = 'https://www.wildling.shoes/en';
const REPAIR_REBELS_ABOUT = 'https://www.repair-rebels.com/';
const REPAIR_REBELS_VOUCHER_EN = 'https://www.repair-rebels.com/voucher/select';
const REPAIR_REBELS_VOUCHER_DE = 'https://www.repair-rebels.com/gutschein/select';

export default function Footer() {
  const { t, i18n } = useTranslation();
  const wildlingAboutUrl = i18n.language === 'de' ? WILDLING_ABOUT_DE : WILDLING_ABOUT_EN;
  const voucherUrl = i18n.language === 'de' ? REPAIR_REBELS_VOUCHER_DE : REPAIR_REBELS_VOUCHER_EN;

  return (
    <footer className={classes.footer}>
      <div className={classes.footerInner}>
        <div className={classes.footerWrapper}>
          <div className={classes.main}>
            <div className={classes.footerNavigationItem}>
              <a className={classes.footerNavigationLink} href="/product/select">
                {t('Footer - Repair')}
              </a>
              <a className={classes.footerNavigationLink} href={REPAIR_REBELS_ABOUT} target="_blank" rel="noopener noreferrer">
                {t('Footer - Repair Rebels')}
              </a>
              <a className={classes.footerNavigationLink} href={wildlingAboutUrl} target="_blank" rel="noopener noreferrer">
                {t('Footer - Wildling Shoes')}
              </a>
              <a className={classes.footerNavigationLink} href={voucherUrl} target="_blank" rel="noopener noreferrer">
                {t('Footer - Gift Vouchers')}
              </a>
            </div>
            <div className={classes.footerNavigationItem}>
              <Link className={classes.footerNavigationLink} to={getPage('imprint')}>
                {t('Imprint')}
              </Link>
              <Link className={classes.footerNavigationLink} to={getPage('privacyPolicy')}>
                {t('Privacy Policy')}
              </Link>
              <Link className={classes.footerNavigationLink} to={getPage('terms')}>
                {t('Terms and Conditions')}
              </Link>
              <Link className={classes.footerNavigationLink} to={getPage('withdrawal')}>
                {t('Right of Withdrawal')}
              </Link>
            </div>
          </div>

          <div className={classes.logosGroup}>
            <div className={classes.paypalImageBlock}>
              <LazyLoadImage className={classes.paypal} alt="PayPal" src={paypalLogo} width={140} height={60} effect="blur" />
            </div>
            <div className={classes.paypalImageBlock}>
              <LazyLoadImage className={classes.paypal} alt="DHL" src={dhlLogo} width={140} height={31} effect="blur" />
            </div>
          </div>

          <div className={classes.contactGroup}>
            <div className={classes.contactBlock}>
              <div className={classes.contactHeading}>{t('Contact Information - Contact Us')}</div>
              <a href="mailto:orders-wildling@repair-rebels.com" className={classes.contactLink}>
                orders-wildling@repair-rebels.com
              </a>
              <a href="tel:+49 173 5204782" className={classes.contactLink}>
                +49 173 5204782
              </a>
            </div>
            <div className={classes.socials}>
              <a className={classes.socialLink} href="https://www.instagram.com/repair_rebels" target="_blank" rel="noopener noreferrer">
                <Instagram title="Instagram" width={26} height={26} />
              </a>
              <a className={classes.socialLink} href="https://www.facebook.com/repairrebels" target="_blank" rel="noopener noreferrer">
                <Facebook title="Facebook" width={26} height={26} />
              </a>
              <a className={classes.socialLink} href="https://www.linkedin.com/company/repair-rebels" target="_blank" rel="noopener noreferrer">
                <LinkedIn title="LinkedIn" width={26} height={26} />
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
